<template>
<div id="index">
  <div class="message" v-if="(type==='message')||(active && !type && stopDrawTime==='end')">
    <img class="bg" src="../img/minor.jpg" alt="">
    <div class="minor-btn" @click="checkAuth"></div>
    <img class="img" :src="$state.brandInfo.img" alt="">
    <div class="footer">
      <div class="minor-rule" @click="jumpMinorRule">活动规则</div>
    </div>
  </div>
  <div class="guess" v-if="(type==='guess')||(active && !type && stopDrawTime!=='end')">
    <img class="bg" src="../img/index.jpg" alt="">
    <img class="img" :src="$state.brandInfo.img" alt="">
    <div class="to-auth" @click="checkAuth"></div>
    <div class="init" @click="checkAuth"></div>
    <div class="rule-btn" @click="jumpRule">活动规则</div>
  </div>
</div>
</template>

<script>
import {
  indexAuth,
  jumpPage
} from '../mixins/functions.js'
import mixin from '../mixins/mixin'
import {
  getQueryString
} from 'common/js/util'
export default {
  name: 'index',
  data() {
    return {
      title: false,
      type: '',
      isShow: false,
      active:false
    }
  },
  created() {
    this.type = getQueryString('type')||''
    this.getTimeInfo()
  },
  mixins: [mixin],
  watch: {
    serverTime(val) {
      if(!this.active){
          this.active = true
      }
      this.getStopTime()
      if (this.stopDrawTime === 'end' && !this.title) {
        this.$type(1)
        this.title = true
      }
    }
  },
  methods: {
    checkAuth() {
      indexAuth.call(this)
    },
    jumpRule() {
      jumpPage.call(this, {
        pageName: 'rule'
      })
    },
    jumpMinorRule() {
      jumpPage.call(this, {
        pageName: 'minorrule'
      })
    }
  }
}
</script>

<style lang="scss">
#index {
    position: relative;
}
.bg {
    width: 100%;
}
.guess {
    background: #a10913;
    padding-bottom: 30px;
    position: relative;
    .to-auth{
      position: absolute;
      top:1316px;
      width:750px;
      height:250px;
    }
    .img {
        position: absolute;
        top: 550px;
        right: 10px;
        width: 350px;
    }
}
.message {
    position: relative;
    background: #fb890c;
    width: 100%;
    height: 100vh;
    .img {
        position: absolute;
        top: 530px;
        right: 10px;
        width: 350px;
    }
}
.init {
    position: absolute;
    top: 680px;
    left:81px;
    width: 588px;
    height: 134px;
    margin: 30px auto 0;
    animation: btnScale 1.2s infinite ease-in;
    background: url("../img/btn.png") center/contain no-repeat;
}
.minor-btn {
    position: absolute;
    top: 712px;
    width: 100%;
    height: 122px;
    animation: btnScale 1.2s infinite ease-in;
    background: url("../img/minor-btn.png") center/contain no-repeat;
}
.footer {
    padding: 30px 0;
    background: #fb890c;
}
.minor-rule {
    width: 180px;
    height: 40px;
    line-height: 40px;
    color: #e84d1a;
    border: 1px solid #ff5821;
    border-radius: 20px;
    margin: 0 auto;
    text-align: center;
}
.rule-btn {
    position: absolute;
    top: 100px;
    right: 0;
    border: 0;
    height: 40px;
    color: #fff;
    padding: 0 20px;
    font-size: 26px;
    border: 2px solid #fe5e5c;
    border-right: 0;
    display: flex;
    align-items: center;
    box-sizing: content-box;
    background: transparent;
    border-top-left-radius: 21px;
    border-bottom-left-radius: 21px;
    &::after {
        content: '';
        display: inline-block;
        position: absolute;
        width: 0;
        height: 0;
        right: 0;
        top: 15px;
        border-style: solid;
        border-width: 10px 10px 0;
        border-color: #fff transparent transparent;
        transform: rotate(-90deg);
    }
}

</style>
